import { ACTIONS_KPI } from '../_constants/kpi.constants';

const initialState = {
  byId: {},
};

export function kpiReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_KPI.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_KPI.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_KPI.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default kpiReducer;
